
export default function ViewerLineItemsContainer({ component, children }) {
    return (
        <div>
            {component.componentType !== 'Display Text' && <label className="flex-grow-1">{component && typeof component.question === "string" && component.question}</label>}
            {children}
        </div>
    )
}
